module.exports = __webpack_public_path__ + "img/9788964451137.9fc4b6cf.jpg";